import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=aa2c1b4c&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa2c1b4c')) {
      api.createRecord('aa2c1b4c', component.options)
    } else {
      api.reload('aa2c1b4c', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=aa2c1b4c&", function () {
      api.rerender('aa2c1b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UwaQmBcBT1Uj/JS/comp/ErrorMessage.vue"
export default component.exports